import SettingsTableModal from "./SettingsTableModal";

export default SettingsTableModal;